module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Villars-Sainte-Croix-e8c6e7ef3ad5087387d5a95af6b3f3b2.svg";